import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { UsuariosPorCidadeChart } from './DashboardAnalyticsCharts';
import DadosInsuficientes from './DadosInsuficientes';

const UsuariosPorCidade = () => {
  const { data, loading } = useSelector((state) => ({
    data: state.DashboardAnalytics.google.data.usuariosPorCidade,
    loading: state.DashboardAnalytics.google.loading
  }));

  const [chartLabels, chartData] = useMemo(() => {
    const labels = [];
    const values = [];
    if (data) {
      data.rows.forEach((row) => {
        labels.push(row.dimensionValues[0].value);
        values.push(row.metricValues[0].value);
      });
    }

    return [labels, values];
  }, [data]);

  let noDataPlaceholder;
  if (!loading && chartLabels.length === 0) {
    noDataPlaceholder = <DadosInsuficientes />;
  }

  return (
    <React.Fragment>
      <Col sm={12} xl={6} xxl={4}>
        <Card style={{ minHeight: '436px' }}>
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Usuários por Cidade</h4>
          </CardHeader>
          <CardBody>
            {noDataPlaceholder
              ? noDataPlaceholder
              :
              <div dir="ltr">
                <UsuariosPorCidadeChart seriesData={chartData} seriesLabels={chartLabels} dataColors='["--vz-primary", "--vz-warning", "--vz-info"]' />
              </div>}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default UsuariosPorCidade;
